
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.4 28.65v-9.87a10.6 10.6 0 0121.2 0v9.87","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M27.52 8.57v-4.6h4.96v4.6M24.7 20.11v8.75M30 20.11v8.75M35.3 20.11v8.75M19.46 20.28h21.08M12.37 39.8h35.27v18.7H12.37z"}}),_c('path',{attrs:{"d":"M24.84 58.45v-8.57a5.16 5.16 0 1110.32 0v8.57M12.49 43.13H1.86V58.5h10.52M47.51 43.13h10.63V58.5H47.62M44.94 39.25V28.86H15.06v10.39","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M18.6 39.93L30 32.7l11.4 7.23M30 0v3.97"}})])
          )
        }
      }
    